import React, { PureComponent } from 'react'
import { Layout, PageHeader, Icon, Table } from 'antd'
import {orderDetail} from '_src/api/api'
import moment from 'moment'

import PrevImg from '_src/components/PrevImg/PrevImg'
import {getStatus} from './commo/common'
import './order.less'

class OrderDetail extends PureComponent {
  constructor () {
    super()
    this.state = {
      isLoading: true,
      userAddress: [],
      orderInfo: [],
    }
  }
  componentDidMount () {
    const id = this.props.location.search.replace('?id=', '')
    orderDetail({id})
      .then(res => {
        const data = res.data
        this.setState({
          isLoading: false,
          ...data,
          // 收货地址
          userAddress: [{
            address: data.address,
            mobile: data.mobile,
            consignee: data.consignee,
          }],
          // 订单信息
          orderInfo: [{
            orderSn: data.orderSn,
            logisticCode: data.logisticCode,
            mobile: data.mobile,
            orderSource: data.orderSource,
            createAt: data.createAt,
          }],
          // 费用信息
          moneyInfo: [{

          }],
          infoList: [{
            ...data
          }],
        })
      })
      .catch(err => {
        this.setState({
          isLoading: false,
        })
      })
  }

  render () {
    const {userAddress, orderInfo, infoList, orderGoods, status} = this.state
    return (
      <Layout className='order-detail-page'>
        <PageHeader className='order-detail-title flex-h-a' title={'订单详情 - ' + getStatus(status)} style={{borderLeft: '5px solid #1890ff'}} />
        <ul className='detail-header flex-j-a'>
          <li className={'item ' + (status !== 102 && status !== 103 ? 'select' : '')}>
            <div className="icon-inner"><Icon type="shopping" theme="filled" className='icon' /></div>
            <p className='item-title'>提交订单</p>
            <span className='item-time'>15点10分</span>
          </li>
          <li className={'item ' + (status >= 201 ? 'select' : '')}>
            <div className="icon-inner"><Icon type="account-book" theme="filled" className='icon' /></div>
            <p className='item-title'>支付订单</p>
          </li>
          <li className={'item ' + (status >= 301 ? 'select' : '')}>
            <div className="icon-inner"><Icon type="medicine-box" theme="filled" className='icon' /></div>
            <p className='item-title'>商家发货</p>
          </li>
          <li className={'item ' + (status === 401 ? 'select' : '')}>
            <div className="icon-inner"><Icon type="check-circle" theme="filled" className='icon' /></div>
            <p className='item-title'>确认收货-完成订单</p>
          </li>
        </ul>
        <div className='order-detail-inner'>
          <div className="info-item">
            <PageHeader title={<span><Icon type="profile" /> 基本信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '订单编号',
                    dataIndex: 'orderSn',
                    key: 'orderSn',
                  },
                  {
                    title: '下单时间',
                    dataIndex: 'createAt',
                  },
                  {
                    title: '用户账号',
                    dataIndex: 'mobile',
                  },
                  {
                    title: '支付方式',
                    render: item => '暂时空缺'
                  },
                  {
                    title: '订单来源',
                    dataIndex: 'orderSource',
                    render: item => item === 1 ? 'APP' : 'H5'
                  },
                  {
                    title: '物流单号',
                    dataIndex: 'logisticCode',
                    render: item => item || '无'
                  },
                  {
                    title: '自动确认收货时间',
                    dataIndex: 'saleExpirAt',
                    render: item => moment(item).format('YYYY-MM-DD HH:mm:ss')
                  },
                ]
              }
              dataSource={orderInfo}
              bordered
              rowKey="orderSn"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="user" /> 收货人信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '收货人',
                    dataIndex: 'consignee',
                    key: 'consignee',
                  },
                  {
                    title: '手机号码',
                    dataIndex: 'mobile',
                  },
                  {
                    title: '收货地址',
                    dataIndex: 'address',
                  },
                ]
              }
              dataSource={userAddress}
              bordered
              rowKey="consignee"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="file-search" /> 商品信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '商品图片',
                    key: 'id',
                    width: 150,
                    render: item => <img src={item.picUrl} style={{width: 120, height: 120, cursor: 'pointer'}} alt='' onClick={() => this.PrevImg.show(item.picUrl)} />
                  },
                  {
                    title: '商品名称',
                    render: item => item.goods.goodsName
                  },
                  {
                    title: '价格',
                    render: item => (item.price / 100).toFixed(2)
                  },
                  {
                    title: '规格',
                    render: item => item.goodsSpecification.specificationsName
                  },
                  {
                    title: '数量',
                    render: item => item.number
                  },
                  {
                    title: '小计',
                    render: item => (item.price / 100 * item.number).toFixed(2)
                  },
                ]
              }
              dataSource={orderGoods}
              bordered
              rowKey="id"
              pagination={false}
            />
          </div>
          <div className="info-item">
            <PageHeader title={<span><Icon type="account-book" /> 费用信息</span>} />
            <Table
              columns={
                [
                  {
                    title: '商品费用（￥）',
                    dataIndex: 'goodsPrice',
                    render: item => item / 100
                  },
                  {
                    title: '运费（￥）',
                    dataIndex: 'freightPrice',
                    render: item => item / 100
                  },
                  {
                    title: '优惠券（￥）',
                    dataIndex: 'couponPrice',
                    render: item => item / 100
                  },
                  {
                    title: '订单总金额（￥）',
                    dataIndex: 'orderPrice',
                    render: item => item / 100
                  },
                  {
                    title: '应付款金额（￥）',
                    dataIndex: 'realPrice',
                    render: item => <span style={{fontSize: 18, fontWeight: 'bold', color: '#1890ff'}} >{item / 100}</span>
                  },
                ]
              }
              dataSource={infoList}
              bordered
              rowKey="id"
              pagination={false}
            />
          </div>
          <PrevImg ref={el => this.PrevImg = el} />
        </div>
      </Layout>
    )
  }
}

export default OrderDetail